export default "__VITE_ASSET__48a471fb__"